<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon style="margin: 0 1em;">accessibility</mat-icon>
				<span>Eigene Mitgliedsdaten</span>
			</div>
			<mat-spinner diameter=30 *ngIf="bLoading" />
		</div>

		<div style="padding:1em;">

			@if( bLoading ) {
				<mat-progress-bar mode="indeterminate" />
			}
			@else if( bError ) {
				<div class="errorWarning">
					Beim Laden der Daten ist ein Fehler aufgetreten.
				</div>
			}
			@else if( !member.mitgliedId ) {
				<h3>
					Ihrem Konto ist kein Mitglied zugeordnet
				</h3>
			}
			@else {
				<app-member-editor 
					[member]="member"
					[users]="users"
					[usernames]="usernames"
				/>
			}


		</div>

	</div>
			
</div>
